const LiveBadge = ({ testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-[var(--fi-red)] text-white text-[11px] font-extrabold uppercase tracking-[0.18em] shadow-[0_2px_8px_rgba(215,38,56,0.35)]"
  >
    <span className="w-2 h-2 rounded-full bg-white live-dot" />
    Ao Vivo
  </span>
);

export default LiveBadge;
